<app-textile-data-overview
  #textileDataOverview
  [gridIdentifier]="GRID_IDENTIFIER"
  iconForCard="product-configuration"
  iconForSearch="filter"
  [columnDefs]="getColumnDefsForListOfProductConfigurations()"
  [textileDataService]="productConfigurations"
  [textileDataType]="textileDataType.PRODUCT_CONFIGURATION"
  [infiniteGrid]="true"
  [cacheBlockSize]="quantityOfRowsToRequestPerSlice"
  [class.loading]="loadingForTheFirstTime"
  [dataSource]="dataSource"
  (reloadData)="reloadProductConfigurations($event)"
  (customSettingsSetup)="navigateToCustomSettings()"
  [canShowCustomSettings]="canShowCustomSettingsButton()"
  [showSearchBar]="false"
  (getAllExportData)="exportAllData($event)"
  [isExporting]="isExporting"
></app-textile-data-overview>

<ag-grid-angular #exportProductConfigurationsGrid [gridOptions]="exportGridOptions" [rowData]="exportData" fxHide></ag-grid-angular>
